import React from "react";
import { Box, Typography } from "@mui/material";
import { useQuery } from "react-query";
import axios from "axios";
import DashboardOutlinedIcon        from "@mui/icons-material/DashboardOutlined";
import CalendarMonthOutlinedIcon    from "@mui/icons-material/CalendarMonthOutlined";
import LocationCityOutlinedIcon     from "@mui/icons-material/LocationCityOutlined";
import StyleOutlinedIcon            from "@mui/icons-material/StyleOutlined";
import EventNoteOutlinedIcon        from "@mui/icons-material/EventNoteOutlined";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import EditOutlinedIcon             from "@mui/icons-material/EditOutlined";
import GroupsOutlinedIcon           from "@mui/icons-material/GroupsOutlined";
import PersonOutlinedIcon           from "@mui/icons-material/PersonOutlined";
import DrawerListItem from "../Components/DrawerListItem";
import withAuth from "../../../Hoc/withAuth";
import { useSidebarAccent } from "../SidebarAccentContext";

const NavSection = ({ label, children, minimized }) => (
  <Box sx={{ mb: 0.5 }}>
    {!minimized && (
      <Typography
        sx={{
          px: 2.25, py: 0.75,
          fontSize: "0.6875rem", fontWeight: 700,
          letterSpacing: "0.1em", textTransform: "uppercase",
          color: "text.disabled",
        }}
      >
        {label}
      </Typography>
    )}
    {children}
  </Box>
);

const OrgUserDrawer = ({ token }) => {
  const { minimized } = useSidebarAccent();

  const { data: membership } = useQuery(
    "orgUserMe",
    () =>
      axios
        .get(`${process.env.REACT_APP_PUBLIC_URL}/orgUsers/me`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((r) => r.data),
    { retry: false, enabled: !!token },
  );

  const active      = membership?.approved === true && membership?.status === "active";
  const orgUuid     = active ? membership?.Org?.uuid : null;
  const permissions = membership?.permissions || {};

  const canEvents  = permissions.manageEvents === true && orgUuid;
  const canProfile = permissions.manageProfile === true;
  const canUsers   = permissions.manageUsers === true;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%", py: 1 }}>
      <Box sx={{ flex: 1, overflowY: "auto", pb: 2 }}>

        <NavSection label="Overview" minimized={minimized}>
          <DrawerListItem name="Dashboard" path="OrgUserDashboard" Icon={DashboardOutlinedIcon} />
        </NavSection>

        <NavSection label="Discover" minimized={minimized}>
          <DrawerListItem name="Events"        path="Events"     Icon={CalendarMonthOutlinedIcon} />
          <DrawerListItem name="Organisations" path="orgs"       Icon={LocationCityOutlinedIcon} />
          <DrawerListItem name="Causes"        path="CausesList" Icon={StyleOutlinedIcon} />
        </NavSection>

        {canEvents && (
          <NavSection label="Events" minimized={minimized}>
            <DrawerListItem name="Manage Events" path={`myEvents/${orgUuid}`}    Icon={EventNoteOutlinedIcon} />
            <DrawerListItem name="Create Event"  path={`CreateEvent/${orgUuid}`} Icon={AddCircleOutlineOutlinedIcon} />
          </NavSection>
        )}

        {(canProfile || canUsers) && (
          <NavSection label="Charity" minimized={minimized}>
            {canProfile && (
              <DrawerListItem name="Edit Profile" path="myorg" Icon={EditOutlinedIcon} exact />
            )}
            {canUsers && (
              <DrawerListItem name="Team" path="OrgAdmin/team" Icon={GroupsOutlinedIcon} />
            )}
          </NavSection>
        )}

        <NavSection label="Account" minimized={minimized}>
          <DrawerListItem name="My Profile" path="profile" Icon={PersonOutlinedIcon} />
        </NavSection>

      </Box>
    </Box>
  );
};

export default withAuth(OrgUserDrawer);
